import { FunctionComponent, useMemo } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider as StoreProvider } from 'react-redux';
import { StorageProvider } from 'components/contexts';
import { createNotification$ } from 'components/elements';
import { getStorage } from 'lib/storage';
import { createStore } from 'store';
import { AppThemeProvider } from './AppThemeProvider';

export const AppProvider: FunctionComponent = props => {
  const { children } = props;

  // Instantiate notification stream
  const notification$ = useMemo(() => createNotification$(), []);

  // Retrieve supported storage type
  const storage = useMemo(() => getStorage('sessionStorage'), []);

  // Instantiate Redux store used throughout the application
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const store = useMemo(() => createStore(notification$), []);

  return (
    <StoreProvider store={store}>
      <HelmetProvider>
        <Helmet
          defaultTitle="Adelante Bank Reconciliation"
          titleTemplate="%s - Adelante Bank Reconciliation"
        />
        <AppThemeProvider notification$={notification$}>
          <StorageProvider value={storage}>{children}</StorageProvider>
        </AppThemeProvider>
      </HelmetProvider>
    </StoreProvider>
  );
};
